
import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/layouts/Icon.vue';
import EnvRepository from '@/repository/EnvRepository';

@Component({
  components: {
    Icon,
  },
})
export default class Erro01View extends Vue {
  errorMessage = '';

  get getTopUrl(): string {
    return EnvRepository.getEnv().VUE_APP_BENEFIT_BENEFITSTATION_URL;
  }

  created(): void {
    const errorSession = sessionStorage.getItem('error');
    if (errorSession) this.errorMessage = errorSession;
  }

  beforeDestroy(): void {
    sessionStorage.removeItem('error');
  }
}
